module.exports = __webpack_public_path__ + "static/img/1-1.817411a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/1-1.png
// module id = Ywfb
// module chunks = 0